/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_DescriptionInputs */

const en_directory_submit_description = /** @type {(inputs: Directory_Submit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a new AI tool, AIGC product, or service for review. Submissions are reviewed before publishing.`)
};

const zh_directory_submit_description = /** @type {(inputs: Directory_Submit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交一个新的 AI 工具、AIGC 产品或服务，审核后发布。`)
};

/**
* | output |
* | --- |
* | "Submit a new AI tool, AIGC product, or service for review. Submissions are reviewed before publishing." |
*
* @param {Directory_Submit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_description = /** @type {((inputs?: Directory_Submit_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_description(inputs)
	return zh_directory_submit_description(inputs)
});
export { directory_submit_description as "directory.submit.description" }